import axios, { AxiosResponse } from "axios";
import QS from "qs";
import { Message } from "element-ui";
import { Loading } from "element-ui";
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.timeout = 10000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error.response.status) {
      Message.error(error.response.message);
      return Promise.reject(error.response);
    }
  }
);

export function get(url: string, params: any): Promise<AxiosResponse> {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
export function post(url: string, params: any): Promise<AxiosResponse> {
  const loadingInstance = Loading.service({ fullscreen: true });
  return new Promise((resolve, reject) => {
    axios
      .post(url, QS.stringify(params))
      .then((res) => {
        setTimeout(() => {
          loadingInstance.close();
        }, 500);
        resolve(res.data);
      })
      .catch((err) => {
        setTimeout(() => {
          loadingInstance.close();
        }, 500);
        Message.error(err.data.message);
        reject(err.data);
      });
  });
}
